import { Col, Row } from "react-bootstrap";
import AccountLayout from "../../components/Layouts/Account";
import {
  BadgeStatus,
  ImageKitImage,
  ShortDate,
} from "../../components/shared/common";
import { Blob_Base_Url } from "../../utils/static";
import dynamic from "next/dynamic";

const ViewService = dynamic(() =>
  import("../../components/account/services/view")
);

const InsertService = dynamic(() =>
  import("../../components/account/services/insert")
);

const ServicesIndex = () => (
  <AccountLayout
    title="My Services"
    subtitle="Get Your Work Done"
    url="/account/request/services"
    insert={true}
    empty={{
      title: "Oops! No Services Found",
      text: "Create Service",
      body: "Looks You Dont Have Any Services",
    }}
    render={(s) => (
      <div className="bg-light mb-3 px-3 py-2 rounded">
        <Row className="align-items-center">
          <Col sm="2 text-center">
            <ImageKitImage
              height={120}
              width={120}
              className="w-100 rounded-8 shadow-sm"
              src={s.category?.imageUri || "/categories/default.png"}
            />
          </Col>
          <Col sm="8">
            <ShortDate data={s.date} />
            <p className="fw-600 mb-0 text-truncate">{s.title}</p>
            <p className={`font-md mb-2 truncate-2 `}>{s.description}</p>
            <div className="flex-between">
              <BadgeStatus data={s.status} />
            </div>
          </Col>
        </Row>
      </div>
    )}
  >
    <ViewService />
    <InsertService />
  </AccountLayout>
);

export default ServicesIndex;
